/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import Permissions from "./permission";
import { useSelector } from 'react-redux';
import { getPermissions, createRole, updateRole } from "../../../api/settings.ts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getUrls } from '../../../api/apiurls.js';

const EditRole = ({ edit, refetchRole }) => {
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const MySwal = withReactContent(Swal);
  const [formDataList, setFormData] = useState({});
  const [permissionData, setPermissionData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [permissionValues, setPermissionValues] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  //
  const getPermissionsData = async () => {
    const res = await getPermissions({});
    if (res?.response) {
     // const defaultSetting = res?.response?.defaultSettings;
     console.log('permissions',res.response);
     //["category", "sub_category", "brands", "variant_attributes"]

    // const excludedModules = ["category", "sub_category", "brands", "variant_attributes","users"];
    const excludedModules = ["category", "sub_category", "brands","users"];

    let filteredPermissoins;
    var tenantType = getUrls().tenantType;

    if(tenantType == 'all') 
      filteredPermissoins = res.response.permissions.filter(item => !excludedModules.includes(item.module));
    else
      filteredPermissoins = res.response.permissions;

      if (!Object.keys(edit).length) {
  
        setFormData((prevState) => ({
          ...prevState,
        
        }));
      }
      const permissionMap = filteredPermissoins;
      setPermissionData(permissionMap);
      mapPermissons(permissionMap);
    }
  };
  //
  const inputChange = (target) => {
    const { value, checked } = target;
    setPermissionValues((prevCheckedValues) => {
      if (checked) {
        return [...prevCheckedValues, value];
      } else {
        return prevCheckedValues.filter((val) => val !== value);
      }
    });
  };
  //
  const mapPermissons = (permissions) => {
    var categories = {};
    permissions.forEach(function (e) {
      if (e?.module) {
        if (!categories[e.module]) {
          categories[e.module] = [];
        }
        categories[e.module].push(e);
      }
    });
    //
    var sections = {};
    for (let [key, value] of Object.entries(categories)) {
      if (!sections[key]) {
        sections[key] = {};
      }
      value.forEach(function (e) {
        if (e.section) {
          sections[key][e.section] = e;
        }
      });
    }
    //
    var operations = {};
    var totalOperations = new Set();
    for (let [key, value] of Object.entries(categories)) {
      // eslint-disable-next-line no-unused-vars
      let key2 = sections[key];
      if (!operations[key]) {
        operations[key] = {};
      }
      value.forEach(function (e) {
        if (!operations[key][e.module]) {
          operations[key][e.module] = {};
        }
        if (e.operation && !operations[key][e.module][e.operation]) {
          operations[key][e.module][e.operation] = e;
          totalOperations.add(e.operation);
        }
      });
    }
    const reportRows = [];
    const toolRows = [];
    const settingRows = [];
    const assistantRows = [];
    const chatRows = [];
    const pulseRows = [];
    const eventRows = [];
    const flowForMobile = [];
    const permissionValues = [];
    //
    for (let [key1, value1] of Object.entries(operations)) {
      for (let [key2, value2] of Object.entries(value1)) {
        var obj = {};
        obj.pagename = key2;
        for (let [key3, value3] of Object.entries(value2)) {
          obj[key3] = value3._id;
          if (Object.keys(edit).length) {
            edit.permissions?.forEach((element) => {
              if (element?._id === value3?._id) {
                permissionValues.push(value3._id);
              }
            });
          }
        }
        //
          reportRows.push(obj);
         if (key1 === "Tool") {
          toolRows.push(obj);
        } else if (key1 === "Settings") {
          settingRows.push(obj);
        } else if (key1 === "Assistant") {
          assistantRows.push(obj);
        } else if (key1 === "Chat") {
          chatRows.push(obj);
        } else if (key1 === "Pulse") {
          pulseRows.push(obj);
        } else if (key1 === "Event") {
          eventRows.push(obj);
        } else if (key1 === "Flow for mobile") {
          flowForMobile.push(obj);
        }
      }
    }
    //
    const myReportRows = [
      ...reportRows,
      ...toolRows,
      ...settingRows,
      ...assistantRows,
      ...chatRows,
      ...pulseRows,
      ...eventRows,
      ...flowForMobile,
    ];
    setTableData(myReportRows);
    setPermissionValues(permissionValues);
  };

  useEffect(() => {
    getPermissionsData();
  }, []);

  useEffect(() => {
    const handleModalOpen = () => {
      setFormData({});
      setPermissionValues([])
    };

    document.getElementById("add-units")?.addEventListener("show.bs.modal", handleModalOpen);
    
    return () => {
      document.getElementById("add-units")?.removeEventListener("show.bs.modal", handleModalOpen);
    };
  }, []);

  useEffect(() => {
    console.log('edit',edit);
    const { title, description } = edit;
    if (Object.keys(edit).length) {
      if (edit.config) {
        setFormData({
          title,
          description,
        });
      } else {
        setFormData({
          title,
          description,
        });
      }
    } else {
      setFormData({});
    }
    mapPermissons(permissionData);
  }, [edit]);


  useEffect(() => {
    const { title, description } = edit;
    if (Object.keys(edit).length) {
      if (edit.config) {
        setFormData({
          title,
          description,
        });
      } else {
        setFormData({
          title,
          description,
        });
      }
    } else {
      setFormData({});
    }
    mapPermissons(permissionData);
  }, [edit]);
  
  
  const submit = async (event) => {
    event.preventDefault();
    const payload = {
      // storeId: formDataList.storeId,
      ...formDataList,
      "permissionsArray": permissionValues,
    }
    if (!Object.keys(edit).length) {
      setBtnLoading(true);
      try {
        const res = await createRole(payload);
        if (res) {
          document.getElementById("closeButton").click();
          setBtnLoading(false);
          refetchRole()
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: t?.[l]?.["created_successfully"] || "Create Successfully!",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        setBtnLoading(false);
        console.log(error);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } else {
      setBtnLoading(true);
      payload._id = edit._id;
      try {
        const res = await updateRole(payload);
        if (res) {
          document.getElementById("closeButton").click();
          setBtnLoading(false);
          refetchRole();
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: t?.[l]?.["update_successfully?"] || "Update Successfully!",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        setBtnLoading(false);
        console.log(error.response.data.message);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };
  return (
    <div>
      {/* Add Role */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content" style={{ maxWidth: "650px" }}>
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{t[l]?.["create_role"] || "Create Role"}</h4>
                  </div>
                  <button
                   id="closeButton"
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="row">
                      <div className="col-lg-6 mb-3">
                        <label className="form-label">{t[l]?.["role_name"] || "Role Name"}</label>
                        <input
                          type="text"
                          required
                          value={formDataList?.title || ""}
                          className="form-control"
                          name="title"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-lg-6 mb-3">
                        <div className="input-blocks">
                          <label>{t[l]?.["description"] || "Description"}</label>
                          <input
                            type="text"
                            value={formDataList?.description || ""}
                            className="form-control"
                            name="description"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                   
                    </div>
                    <div className="mb-0">
                      <Permissions
                        tableData={tableData}
                        premissionV={permissionValues}
                        inputChange={inputChange}
                      />
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                          {t[l]?.["cancel"] || 'Cancel'}
                      </button>
                      <button disabled={btnLoading} type="submit" className="btn btn-submit">
                        {/* {btnLoading ? 'Wait...':'Save'} */}
                        {t[l]?.[btnLoading ? "wait" : "save"] || (btnLoading ? "Wait..." : "Save")}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Role */}
    </div>
  );
};

export default EditRole;